const HelpCenterNew = ({ className }) => {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66602 16H7.33268V13.3333H4.66602V16ZM5.99935 0C3.05268 0 0.666016 2.38667 0.666016 5.33333H3.33268C3.33268 3.86667 4.53268 2.66667 5.99935 2.66667C7.46602 2.66667 8.66602 3.86667 8.66602 5.33333C8.66602 8 4.66602 7.66667 4.66602 12H7.33268C7.33268 9 11.3327 8.66667 11.3327 5.33333C11.3327 2.38667 8.94602 0 5.99935 0Z"
        fill="#2A7050"
        className={className}
      />
    </svg>
  );
};

export { HelpCenterNew };
